import gql from 'graphql-tag';
import FieldsEmployee from "graphql/fields/FieldsEmployee";
import FieldsDepartment from "graphql/fields/FieldsDepartment";
import FieldsJobtitle from "graphql/fields/FieldsJobtitle";
import HelperGraphql from 'utils/helper-graphql'
import FieldsTeam from "graphql/fields/FieldsTeam";

const fields = {
	'guid': '[String]',
	'team_guid': 'String',
	'visible_for_employees': '[String]',
	'kind': '[String]',
	'verified': '[String]',
	'active': '[String]',
};

export default gql(`
	query employees( ${ HelperGraphql.createFields( fields ) } )  {
		employees( ${ HelperGraphql.createVariables( fields ) } )  {
			${FieldsEmployee}
			is_in_office
			
			department {
				${FieldsDepartment}
			}
			
			jobtitle {
				${FieldsJobtitle}
			}
			
			team {
				${FieldsTeam}
			}
		}
	}
`);

